import type { LegalEntity } from '@pflegenavi/shared/api';
import type { KycWarning } from '@pflegenavi/shared-frontend/platform';
import { getKycWarning } from '@pflegenavi/shared-frontend/platform';

export interface LegalEntityKycWarning {
  legalEntity: LegalEntity;
  warning: KycWarning;
}

/** Skips entities without hosted IDV (NH web cannot verify them) or without a MangoPay user. */
export const getLegalEntityKycWarnings = (
  legalEntities: LegalEntity[],
  today: Date
): LegalEntityKycWarning[] =>
  legalEntities.flatMap((legalEntity) => {
    if (
      !legalEntity.mangopay_hosted_idv_enabled ||
      !legalEntity.has_mangopay_user
    ) {
      return [];
    }
    const warning = getKycWarning(legalEntity, today);
    return warning ? [{ legalEntity, warning }] : [];
  });
